var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-btn',{attrs:{"icon":"","color":"secondary"},on:{"click":_vm.printInvoice}},[_c('v-icon',{staticClass:"ms-2",attrs:{"color":"primary"}},[_vm._v("mdi-download")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }